import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showDialog, hideDialog } from '../../../../core/actions';
import { selectDetergentModalIntent } from '../../reducer';
import { CLEAR_DETERGENT_MODAL_INTENT } from '../../actions';
import DetergentLoadingModal from './DetergentLoadingModal';
import DetergentCompleteModal from './DetergentCompleteModal';
import DetergentErrorModal from './DetergentErrorModal';

/**
 * Listens for detergent modal intents (from sagas) and shows the appropriate modal.
 * Mounted at app level so it can respond to POST_DETERGENT_MIGRATION_* actions.
 */
const DetergentModalBridge = (): null => {
  const dispatch = useDispatch();
  const intent = useSelector(selectDetergentModalIntent);
  const prevIntentRef = useRef<typeof intent>(null);

  useEffect(() => {
    if (!intent || intent === prevIntentRef.current) {
      return;
    }
    prevIntentRef.current = intent;

    const hide = () => dispatch(hideDialog());

    dispatch(hideDialog());

    if (intent.type === 'loading') {
      dispatch(
        showDialog('DETERGENT_MIGRATION_LOADING', {
          specificComponent: DetergentLoadingModal,
          isOpen: true,
          hide,
        })
      );
    } else if (intent.type === 'complete') {
      dispatch(
        showDialog('DETERGENT_MIGRATION_LOADING', {
          specificComponent: DetergentCompleteModal,
          isOpen: true,
          detergentPods: intent.detergentPods || [],
          hide,
        })
      );
    } else if (intent.type === 'error') {
      dispatch(
        showDialog('DETERGENT_MIGRATION_LOADING', {
          specificComponent: DetergentErrorModal,
          isOpen: true,
          errorMessage: intent.errorMessage,
          hide,
        })
      );
    }

    dispatch({ type: CLEAR_DETERGENT_MODAL_INTENT });
  }, [intent, dispatch]);

  return null;
};

export default DetergentModalBridge;
